import _ from 'lodash/fp';

export const transformStops = _.compose(
  _.flatten,
  _.map(stop => {
    const v = stop[1] / 3;
    return [[stop[0], v], [stop[0], v + 0.3333], [stop[0], v + 0.6666]];
  })
);



// WEBPACK FOOTER //
// ./src/components/ramp/util/index.js